import { render, staticRenderFns } from "./shoplist.vue?vue&type=template&id=0313e3c4&scoped=true&"
import script from "./shoplist.vue?vue&type=script&lang=js&"
export * from "./shoplist.vue?vue&type=script&lang=js&"
import style0 from "./shoplist.vue?vue&type=style&index=0&id=0313e3c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313e3c4",
  null
  
)

export default component.exports